import { NativeSupportHandlerLegacy } from '@bharatpe/native-support-handler';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { makeStyles } from '@bharatpe/bharat-ui/web/Styles';
import Box from '@bharatpe/bharat-ui/web/Box';
import Typography from '@bharatpe/bharat-ui/web/Typography';
import { UPI_INTENT_CONSTANT } from 'constants/data';
import {
	triggerUpdatePaymentModesApi,
	updatePaymentModesSlice,
	useUpdatedPaymentModes,
	usePaymentModes,
	usePaymentStatus,
	trigeerGetPaymentStatusApi,
	triggerApplyPostpeCashbackApi,
	applyPostpeCashbackSlice,
	useApplyPostpeCashback,
	useCashbackDetails,
} from 'Slices';
import { registerSlice } from 'store';
import BottomSheet from '@bharatpe/bharat-ui/web/BottomSheet';
import OTPCard from '@bharatpe/bharat-ui/web/OTPCard';
import PaymentOptionsList from '@bharatpe/bharat-ui/web/PaymentOptionsList';
import Footer from '@bharatpe/bharat-ui/web/Footer';
import UpiHandleInput from '../UpiHandleInput';
import Icon1 from 'assets/images/Icons.svg';
import visa from 'assets/images/visaIcon.png';
import master from 'assets/images/masterIcon.png';
import rupay from 'assets/images/rupayIcon.png';
import PhonePe from 'assets/images/phonePeIcon.png';
import GooglePay from 'assets/images/gpayIcon.png';
import amazon from 'assets/images/amazonIcon.png';
import paytm from 'assets/images/paytmIcon.png';
import LoaderImageNew from 'assets/images/loader-bui.gif';
import newLoader from 'assets/images/12pcLoader.gif';
import bharatPeIcon from 'assets/images/bharatpe-icon.png';
import addCardIcon from 'assets/images/addCard.svg';
import postPeMoneyIcon from 'assets/images/postPeMoneyIcon.svg';
import { useDispatch } from 'react-redux';
import { globalId } from 'index';
import { CancelPaymentApi, GenerateOtpDetails, GetCardInfoFromIIN, ResendOtpDetails } from '../../../Services';
import { useHistory } from 'react-router';
import useInterval from 'Hooks/useInterval';
import { loadState, saveState } from 'utils/LocalStorage';
import { formatCurrency } from 'utils/formatCurrency';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';
import Button from '@bharatpe/bharat-ui/web/Button';
import Timer from '../Timer';
import { useSelectedLanguage } from 'Slices';
import { isSwipeClient, showPostPeUI, showTwelvePcUI, showUnityUi } from 'utils/Utils';
import { getURLParameter, removePostpeLoader, showPostpeLoader } from 'utils/nativeSupport';
import PostpePaymentOptionsList from '../PostpePaymentOptionsList';
import Toasty from '../Toasty';
import InputPostPe from '../InputPostPe';
import Switch from '../Switch';
import SavedCardItem from '../SavedCardItem';
import BankList from '../BankList';
import HeaderPostPe from '../HeaderPostPe';
import Header from '@bharatpe/bharat-ui/web/Header';
import backArrowPostPe from 'assets/images/backArrowPostPe.svg';
import LoaderNew from '../Loader';
import Loader from '@bharatpe/bharat-ui/web/Loader';
import FormControlLabel from '@bharatpe/bharat-ui/web/FormControlLabel';
import Checkbox from '@bharatpe/bharat-ui/web/Checkbox';
import Icon from '@bharatpe/bharat-ui/web/Icon';
import check from '../../../assets/images/postpeCheck1.svg';
import uncheck from '../../../assets/images/postpeUncheck1.svg';
import downArrowBlue from 'assets/images/downArrowBlue.png';

const applicationNameEncoded = getURLParameter(window.location.href, 'application');
const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();
const isShowUnityUi = showUnityUi();
const isShowAlternateUi = isShowPostPeUI || isShowUnityUi;
const isShowSwipeModes = isSwipeClient();
declare global {
	interface Window {
		Razorpay: any;
		Cashfree: any;
	}
}
let interval1: ReturnType<typeof setTimeout>;

const useStyle = makeStyles(() => ({
	root: {
		marginBottom: '40px',
		backgroundColor: isShowTwelvePcUI || isShowAlternateUi ? '#FFFFFF' : '',
	},
	mainContainer: {
		margin: isShowAlternateUi ? '0 1rem' : '1rem 1rem 0',
		backgroundColor: isShowTwelvePcUI || isShowAlternateUi ? '#FFFFFF' : '#e8e8e8',
	},
	paymentModal: {
		gap: '16px',
		borderRadius: '8px',
		padding: '16px',
		backgroundColor: isShowTwelvePcUI ? '#E6EEEF' : '#FFFFFF',
	},
	postPeAmountCard: {
		borderRadius: '8px',
		padding: '16px',
		backgroundColor: '#E9F8FF',
	},
	postpeCashbackCardColor: {
		backgroundColor: '#FFF2F7 !important',
	},
	postpeCashbackCardMargin: {
		marginRight: '0 !important',
	},
	paymentHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	paymentSubHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingTop: '8px',
	},
	subHeader: {
		color: '#4F4F4F',
	},
	subHeader1: {
		paddingTop: '4px',
	},
	subHeader2: {
		fontSize: '14px !important',
		fontWeight: 900,
		fontFamily: 'Regular',
	},
	selectPaymentMethodText: {
		paddingTop: '18px',
	},
	bottomButton: {
		width: '100%',
		backgroundColor: '#FFFFFF',
		margin: '57px 0px 0px -1rem',
		padding: '8px 16px',
	},
	btnContainer: {
		width: '100%',
	},
	btnClass: {
		color: '#FFFFFF !important',
		fontSize: '12px !important',
		fontWeight: 900,
		fontFamily: 'Regular',
	},
	btnContainerAmount: {
		fontSize: '12px !important',
		fontWeight: 900,
		fontFamily: 'Regular',
	},
	btnText: {
		paddingRight: '6px',
	},
	otpHeader: {
		paddingTop: '8px',
		paddingLeft: '16px',
	},
	loader__overlay: {
		background: 'rgba(0, 0, 0, 0.5)',
		bottom: 0,
		left: 0,
		position: 'fixed',
		right: 0,
		top: 0,
		zIndex: 1,
	},
	orderCancelBtn: {
		fontFamily: 'Heavy',
		fontSize: '0.875rem',
		padding: '0.25rem 1rem',
	},
	loaderElement: {
		height: '50px',
		objectFit: 'contain',
		width: '50px',
		marginBottom: '0.5rem',
	},
	postPeLoaderElement: {
		width: '20%',
		objectFit: 'contain',
		marginBottom: '0.5rem',
	},
	newLoaderElement: {
		height: '220px',
		objectFit: 'contain',
		marginBottom: '-3.5rem',
		marginTop: '-2rem',
	},
	loaderBackground: {
		background: '#FFFFFF',
		borderRadius: '10px',
		boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
		minWidth: '65vw',
		maxWidth: '70vw',
		padding: '15px 25px',
		zIndex: 25,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	loaderText: {
		alignItems: 'baseline',
		justifyContent: 'space-between',
		display: 'flex',
		marginTop: '1rem',
	},
	paymentLoaderMainContainer: {
		bottom: 0,
		left: 0,
		position: 'absolute',
		right: 0,
		top: 0,
		zIndex: 99,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	opaq: {
		opacity: 0,
		marginBottom: '-20vh',
	},
	outlinePayment: {
		border: isShowTwelvePcUI || isShowAlternateUi ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
		borderRadius: isShowTwelvePcUI || isShowAlternateUi ? '8px' : '',
		margin: '12px 0',
	},
	footerNewContainer: {
		bottom: '0',
		left: '0',
		zIndex: 9,
		background: '#ffffff',
	},
	twelvePcButton: {
		background: '#035857',
		borderRadius: '48px',
		padding: '14px 30px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		color: '#ffffff',
	},
	twelvePcButtonDisabled: {
		background: '#D0D0D0',
		borderRadius: '48px',
		padding: '14px 30px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		color: '#ffffff',
	},
	twelvePcButtonOutline: {
		background: '#ffffff',
		borderRadius: '48px',
		padding: '14px 30px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		color: '#035857',
		border: '1px solid #035857',
	},
	width100Imp: {
		width: '100% !important',
	},
	bharatpeIcon: {
		width: '18px',
	},
	bottomBlock: {
		background: '#ffffff',
		height: '70px',
	},
	postpeButton: {
		border: isShowUnityUi ? '1px solid #FFCD1E' : '1px solid #009CDE',
		borderRadius: '10px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		background: isShowUnityUi ? '#FFCD1E' : 'linear-gradient(to right, #66BEEF, #009CDE)',
		color: isShowUnityUi ? '#000000' : '#FFFFFF',
		fontSize: '1rem',
		fontFamily: isShowUnityUi ? 'PoppinsHeavy' : 'PoppinsExtraHeavy',
		padding: '12px 18px',
		textTransform: 'capitalize',
		outline: 'none',
	},
	postpeMoreBanksButton: {
		borderRadius: '10px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		background: '#FFFFFF',
		border: '2px solid #009CDE',
		color: '#009CDE',
		fontSize: '1rem',
		fontFamily: 'PoppinsHeavy',
		padding: '12px 18px',
		textTransform: 'capitalize',
		outline: 'none',
	},
	postpeButtonDisabled: {
		border: '1px solid #D0D0D0',
		borderRadius: '10px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		background: '#D0D0D0',
		color: '#FFFFFF',
		fontSize: '1rem',
		fontFamily: 'PoppinsExtraHeavy',
		padding: '12px 18px',
		textTransform: 'capitalize',
		outline: 'none',
	},
	postpeButtonFont: {
		fontSize: '0.85rem !important',
	},
	postpeButtonOutline: {
		background: '#ffffff',
		borderRadius: '10px',
		padding: '12px 18px',
		textAlign: 'center',
		display: 'inline-block',
		fontSize: '1rem',
		width: '90%',
		color: '#009CDE',
		border: '1px solid #009CDE',
		fontFamily: 'PoppinsExtraHeavy',
		textTransform: 'capitalize',
	},
	amountPayStyle: {
		fontFamily: 'PoppinsLight',
		fontSize: '13px', // TODO: Convert to rem
		lineHeight: '19px',
		//textTransform: 'uppercase',
		color: '#4F4F4F',
	},
	amountPayValue: {
		fontFamily: 'PoppinsMedium',
		fontSize: '28px', // TODO: Convert to rem
		lineHeight: '36px',
		color: '#1F1F1F',
	},
	rupeeSymbolUnity: {
		fontSize: '28px', // TODO: Convert to rem
		lineHeight: '36px',
		color: '#1F1F1F',
	},
	selectPaymentText: {
		fontFamily: 'PoppinsMedium',
		fontSize: '16px', // TODO: Convert to rem
		lineHeight: '22px',
		color: '#1F1F1F',
	},
	textLonger: {
		fontFamily: 'PoppinsRegular',
		fontSize: '13px', // TODO: Convert to rem
		lineHeight: '19px',
		color: '#1F1F1F',
	},
	postPePaymentOptionCard: {
		borderRadius: '10px',
		backgroundColor: '#FFFFFF',
		overflow: 'hidden',
		boxShadow: '0px 2px 25px rgba(0, 0, 0, 0.15)',
		marginTop: '0.75rem',
	},
	unityPaymentAmountCard: {
		borderRadius: '10px',
		backgroundColor: '#FFFFFF',
		overflow: 'hidden',
		boxShadow: '0px 2px 25px rgba(0, 0, 0, 0.15)',
		marginTop: '0.75rem',
	},
	selectFontSize: {
		fontSize: '14px',
	},
	saveCardStyle: {
		fontFamily: isShowAlternateUi ? 'PoppinsLight' : 'Light',
		fontSize: '14px', // TODO: Convert to rem
		lineHeight: '19px',
		color: '#4F4F4F',
	},
	savedCardInfoStyle: {
		//fontFamily: 'PoppinsLight',
		borderRadius: '10px',
		border: '1px solid #C6C6C6',
	},
	addNewCardStyle: {
		fontFamily: isShowAlternateUi ? 'PoppinsMedium' : 'SemiBold',
		fontSize: '13px', // TODO: Convert to rem
		lineHeight: '19px',
		color: isShowAlternateUi ? '#009CDE' : isShowTwelvePcUI ? '#035857' : '#2b80ff',
	},
	borderCardBlue: {
		border: isShowAlternateUi
			? '1px solid #009CDE !important'
			: isShowTwelvePcUI
			? '1px solid #035857 !important'
			: '1px solid #2b80ff !important',
	},
	cardModalHeading: {
		fontFamily: isShowAlternateUi ? 'PoppinsMedium' : 'SemiBold',
		fontSize: '18px', // TODO: Convert to rem
		lineHeight: '24px',
		color: '#252525',
	},
	bankCardLogoStyle: {
		fontFamily: 'PoppinsLight',
		borderRadius: '10px',
		border: '0.75px solid #AAAAAA',
		boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
		width: '13vw',
		//height: '12vh',
		textAlign: 'center',
		margin: '0.5rem',
		overflow: 'scroll',
	},
	bankListOuterLayout: {
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		display: 'flex',
	},
	bankListTextStyle: {
		fontFamily: isShowAlternateUi ? 'PoppinsLight' : 'Light',
		fontSize: '10px',
		lineHeight: '13px',
		color: '#4F4F4F',
		width: '100%',
	},
	bankLogoImg: {
		width: '7vw',
		height: '7vw',
	},
	bankLogoImgDefault: {
		width: '6vw',
		height: '6vw',
	},
	availableCashback: {
		fontFamily: 'PoppinsMedium',
		fontSize: '13px', // TODO: Convert to rem
		lineHeight: '19px',
		color: '#000000',
	},
	cashbackText: {
		fontFamily: 'PoppinsMedium',
		fontSize: '13px', // TODO: Convert to rem
		lineHeight: '19px',
		color: '#009CDE',
	},
	cashbackApplied: {
		color: '#009688 !important',
	},
	twelvepcLendenText: {
		fontFamily: 'PoppinsRegular',
		fontSize: '10px',
		lineHeight: '13px',
		color: '#000000',
		textAlign: 'center',
	},
	upiIconWidth: {
		width: '18px',
	},
	cardIconHeight: {
		height: '11px',
	},
	gpayIconWidth: {
		width: '22px',
	},
}));
interface Props {
	paymentModes?: any;
	fullScreen?: boolean;
	merchantData?: unknown;
	bankListCallback: (val: boolean) => void;
}

registerSlice(updatePaymentModesSlice);
registerSlice(applyPostpeCashbackSlice);
const PaymentMethod: React.FC<Props> = ({ paymentModes, fullScreen, merchantData, bankListCallback }) => {
	const classes = useStyle();
	const dispatch = useDispatch();
	const postPaymentModesResponse = useUpdatedPaymentModes();
	const applyCashbackApiResponse = useApplyPostpeCashback();
	const postpeCashbackDetailsResponse = useCashbackDetails();
	const inputRef: any = useRef(null);
	const inputRef2: any = useRef(null);
	const inputRef3: any = useRef(null);
	const inputRef4: any = useRef(null);
	const Token = getURLParameter(window.location.href, 'token') || getURLParameter(window.location.href, 'visa');
	const [loading, setLoading] = useState(false);
	const [selectedOptionId, setSelectedoptionId] = useState('');
	const [selectedGateway, setSelectedGateway] = useState('');
	const [showOtpModal, setShowOtpModal] = useState(false);
	const usePaymentMode = usePaymentModes();
	const history = useHistory();
	const [isPSPModalVisible, setIsPSPModalVisible] = useState(false);
	const [reopenPspModal, setReopenPspModal] = useState(false);
	const [upiIntentLoader, setUpiIntentLoader] = useState(false);
	const [counter, setCounter] = useState(1);
	const [upiPolling, setUpiPolling] = useState(false);
	const [isPSPModalVisible1, setIsPSPModalVisible1] = useState(false);
	const [isCancelIntentModalVisible, setIsCancelIntentModalVisible] = useState(false);
	const [fiveMinTimer, setFiveMinTimer] = useState(false);
	const [postPecounter, setPostPeCounter] = useState(0);
	const [parsedTime, setParsedTime] = useState('');
	const isIOS = loadState('upiPaymentFlow', true);
	const [showCardInfoInput, setShowCardInfoInput] = useState(false);
	const [isAddNewCard, setIsAddNewCard] = useState(false);
	const [showBankSelectModal, setShowBankSelectModal] = useState(false);
	const [bankSelected, setBankSelected] = useState('');
	const [cardNo, setCardNo] = useState('');
	const [cardNoTrimmed, setCardNoTrimmed] = useState('');
	const [cardHolderName, setCardHolderName] = useState('');
	const [cardMonthValue, setCardMonthValue] = useState('');
	const [cardCVV, setCardCVV] = useState('');
	const [rzpCardType, setRzpCardType] = useState('');
	const [isSaveCard, setIsSaveCard] = useState(true);
	const [isShowCardNoError, setIsShowCardNoError] = useState(false);
	const [isShowCardMonthError, setIsShowCardMonthError] = useState(false);
	const [netbankingOptions, setNetbankingOptions] = useState<any>([]);
	const [savedCardsList, setSavedCardsList] = useState<any>([]);
	const [savedCardsCVV, setSavedCardsCVV] = useState<string>('');
	const [cardFocused, setCardFocused] = useState(-1);
	const [showBankList, setShowBankList] = useState<boolean>(false);
	const [isShowCashbackCard, setIsShowCashbackCard] = useState(false);
	const [postpeCashbackApplied, setPostpeCashbackApplied] = useState(false);
	const [postpeCashbackPayableAmount, setPostpeCashbackPayableAmount] = useState(0);
	const [gpayVpa, setGpayVpa] = useState('');
	const [isGpayVpaValid, setIsGpayVpaValid] = useState(true);
	const [isCashbackCheckboxChecked, setIsCashbackCheckboxChecked] = useState(false);
	const [normalPaymentModes, setNormalPaymentModes] = useState<Array<Record<string, unknown>>>([]);
	const [swipePaymentModes, setSwipePaymentModes] = useState<Array<Record<string, unknown>>>([]);
	const [isShowAllModes, setIsShowAllModes] = useState(true);
	const usepaymentStatus = usePaymentStatus();
	const id = globalId;
	const language = useSelectedLanguage();

	const createData = (paymentModes: any) => {
		// console.log(paymentModes);
		const paymentModesData = Array<Record<string, unknown>>();
		const paymentModesData2 = Array<Record<string, unknown>>();
		let isFpEnabled = false;
		for (let i = 0; i < paymentModes?.length; i++) {
			const list = (paymentModes as any)[i];
			const id = (list as any)?.code;
			const title =
				id === 'UPI' ? (
					<>
						<img
							src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQR1ob-55DWP57fYPivi_raA14gvUOvHPPFN5xPAASMc2H3y8wU5QXqCzCp81PxS-Eohw&usqp=CAU"
							style={{ height: '18px', paddingTop: '2px' }}
						/>
					</>
				) : (
					(list as any)?.displayName
				);
			const subtitle = (list as any)?.amount
				? `${language.BALANCE}: ₹${formatCurrency((list as any)?.amount)}`
				: id === 'UPI' && isShowTwelvePcUI
				? 'Only for your 12% club linked bank account'
				: (list as any)?.description;
			const recommended = isShowSwipeModes ? false : (list as any)?.recommended;
			const recommendedText = language.RECOMMENDED;
			const rightContent =
				id === 'UPI' ? (
					<div className="flex flex-row">
						<img src={PhonePe} className={classes.upiIconWidth} />
						<img src={paytm} className={`ml1 ${classes.upiIconWidth}`} />
						{/* <img src={GooglePay} className={`ml1 ${classes.upiIconWidth}`} /> */}
						<img src={amazon} className={`ml1 ${classes.upiIconWidth}`} />
					</div>
				) : id === 'CC' ? (
					<div className="flex flex-row">
						<img src={visa} className={classes.cardIconHeight} />
						<img src={master} className={`ml1 ${classes.cardIconHeight}`} />
					</div>
				) : id === 'DC' ? (
					<div className="flex flex-row">
						<img src={visa} className={classes.cardIconHeight} />
						<img src={master} className={`ml1 ${classes.cardIconHeight}`} />
						<img src={rupay} className={`ml1 ${classes.cardIconHeight}`} />
					</div>
				) : (
					<></>
				);
			const disabled = !(list as any)?.enabled;
			const selected = i === 0;
			if (selected && !selectedOptionId) {
				setSelectedoptionId(id);
				setSelectedGateway(list?.paymentGateway);
			}
			const paymentGateway = list?.paymentGateway;
			const data = {
				id: id,
				title: title,
				subtitle: subtitle,
				recommended: isShowUnityUi ? false : recommended,
				recommendedText: recommendedText,
				showChildren: false,
				disabled: disabled,
				rightContent: rightContent,
				selected: selected,
				paymentGateway: paymentGateway,
			};
			if (isShowSwipeModes && id === 'FP' && (list as any)?.enabled) {
				setSelectedoptionId(id);
				setSelectedGateway(list?.paymentGateway);
				data.recommended = true;
				data.selected = true;
				paymentModesData2.push(data);
				isFpEnabled = true;
			}
			paymentModesData.push(data);
			if (id === 'UPI' && (list as any)?.subPaymentMode === 'INTENT') {
				const data1 = {
					id: 'GPAY',
					title: 'Google Pay UPI',
					recommended: false,
					recommendedText: '',
					showChildren: true,
					disabled: false,
					rightContent: (
						<div className="flex flex-row">
							<img src={GooglePay} className={`ml1 ${classes.gpayIconWidth}`} />
						</div>
					),
					selected: false,
					paymentGateway: 'BHARATPE_UPI',
					children: (
						<UpiHandleInput
							upiHandleList={['@oksbi', '@okaxis', '@okicici', '@okhdfcbank']}
							setUpiId={setGpayVpa}
							label={'GPay'}
							setIsVpaValid={setIsGpayVpaValid}
							isShowUnityUi={isShowUnityUi}
						/>
					),
				};
				paymentModesData.push(data1);
			}
		}
		if (isShowSwipeModes && isFpEnabled) {
			setIsShowAllModes(false);
			setSwipePaymentModes(paymentModesData2);
		}
		setNormalPaymentModes(paymentModesData);
	};

	useEffect(() => {
		if (paymentModes && paymentModes?.length <= 0) return;
		createData(paymentModes);
	}, [paymentModes]);

	useEffect(() => {
		console.log('UPI FLOW------------->', isIOS);
		setIsPSPModalVisible(isIOS === 'INTENT');
	}, [isPSPModalVisible]);

	useEffect(() => {
		if (
			postpeCashbackDetailsResponse?.data?.cashbackBalance &&
			postpeCashbackDetailsResponse?.data?.maxApplicableCashback > 0
		) {
			setIsShowCashbackCard(true);
			togglePostpeCashback();
		}
	}, [postpeCashbackDetailsResponse]);

	useEffect(() => {
		if (applyCashbackApiResponse.error.length > 1 && !applyCashbackApiResponse.loading) {
			removePostpeLoader();
		}
	}, [applyCashbackApiResponse, applyCashbackApiResponse.error]);

	useEffect(() => {
		if (applyCashbackApiResponse?.data?.payableAmount) {
			setPostpeCashbackApplied(true);
			setPostpeCashbackPayableAmount(applyCashbackApiResponse?.data?.payableAmount);
			handlePostpeCashbackCheckbox();
		}
		removePostpeLoader();
	}, [
		applyCashbackApiResponse,
		applyCashbackApiResponse?.data?.appliedCashback,
		applyCashbackApiResponse?.data?.payableAmount,
	]);

	useEffect(() => {
		if (paymentModes && paymentModes?.length < 1) return;
		for (let i = 0; i < paymentModes?.length; i++) {
			//console.log('net banking options------------->', paymentModes[i]?.options);
			if (paymentModes[i]?.code === 'NB') {
				setNetbankingOptions(paymentModes[i]?.options);
				return;
			}
		}
	}, [paymentModes]);

	/*
		@Polling 
	*/
	useInterval(
		() => {
			if (upiPolling && counter <= 60) {
				dispatch(trigeerGetPaymentStatusApi(id as any));
				setCounter(counter + 1);
			}
		},
		5000,
		usepaymentStatus,
	);

	useEffect(() => {
		if (
			postPaymentModesResponse?.data?.paymentStatus === 'SUCCESS' ||
			postPaymentModesResponse?.data?.paymentStatus === 'FAILURE'
		) {
			handleBack();
		}
	}, [postPaymentModesResponse?.data?.paymentStatus]);

	useEffect(() => {
		if (upiIntentLoader) {
			setTimeout(() => {
				setFiveMinTimer(true);
			}, 15000);
		}
	}, [upiIntentLoader]);

	const TriggerCancelPaymentApi = () => {
		CancelPaymentApi({ txnId: globalId })
			.then((resp: any) => {
				handleBack();
			})
			.catch((err) => {
				handleBack();
				Toasty.error('Something went wrong');
			});
	};

	const TriggerGetCardInfoApi = async (iin: string | number) => {
		const resp = await GetCardInfoFromIIN(iin);
		if (resp.statusCode !== '200') {
			Toasty.error(resp?.message || "Error: Couldn't determine card type");
			return 'NA';
		}
		return await resp;
	};

	const calTime = () => {
		const newTime = postPecounter - 1;
		setPostPeCounter(newTime);
		let min: number | string = calMin(newTime);
		let sec: number | string = calSec(newTime, min);
		min = min.toString();
		sec = sec.toString();
		setParsedTime(`${min.length === 1 ? `${min}` : min} : ${sec.length === 1 ? `0${sec}` : sec}`);
	};

	const calMin = (time: number) => {
		return parseInt((time / 60).toFixed(2));
	};

	const calSec = (time: number, min: number) => {
		const sec = time - min * 60;
		return sec > 0 ? sec : 0;
	};

	useEffect(() => {
		if (!isShowAlternateUi || !upiIntentLoader) return;
		calTime();
	}, []);

	useEffect(() => {
		if (!isShowAlternateUi || !upiIntentLoader) return;

		if (postPecounter === 0) {
			clearTimeout(interval1);
			handleBack();
			console.log('----------------time is up=================');
		}
		if (postPecounter > 0) {
			interval1 = setTimeout(() => calTime(), 1000);

			return () => clearTimeout(interval1);
		} else {
			setPostPeCounter(0);
		}
	}, [postPecounter]);

	useEffect(() => {
		if (!isShowAlternateUi || !upiIntentLoader) return;

		if (upiIntentLoader) {
			showPostpeLoader({
				first_message: 'verifying the',
				start_index: 0,
				range: 9,
				second_message: `transaction (${parsedTime})`,
			});
		}
	}, [parsedTime, upiIntentLoader]);

	useEffect(() => {
		if ((postPaymentModesResponse?.data?.upiIntent && isPSPModalVisible) || isPSPModalVisible1) {
			removePostpeLoader();
			NativeSupportHandlerLegacy.openPSPModal(postPaymentModesResponse?.data?.upiIntent, 'Payment Gateway')
				.then((res) => {
					// do something on success case
					setUpiIntentLoader(true);
					setPostPeCounter(30);
					setUpiPolling(true);
				})
				.catch((errStatus) => {
					if (errStatus === UPI_INTENT_CONSTANT.PSP_MODAL_STATUS.USER_CLOSED) {
						TriggerCancelPaymentApi();
						return;
					}
					if (errStatus === UPI_INTENT_CONSTANT.PSP_MODAL_STATUS.NO_PSP_INSTALLED) {
						setIsPSPModalVisible1(false);
						setReopenPspModal(true);
						toast.error(UPI_INTENT_CONSTANT.MESSAGE_CONSTANT.NO_PSP_APP_FOUND);
					}
					if (errStatus !== UPI_INTENT_CONSTANT.PSP_MODAL_STATUS.USER_CLOSED) {
						setIsPSPModalVisible1(false);
						setReopenPspModal(true);
						toast.error(UPI_INTENT_CONSTANT.MESSAGE_CONSTANT.SOMETHING_WRONG);
					}
				});
		}
	}, [postPaymentModesResponse?.data?.upiIntent, isPSPModalVisible, isPSPModalVisible1]);

	const handleBack = () => {
		const deviceType = loadState('deviceType', true);
		if (usePaymentMode?.data?.transaction?.redirectURIDeeplink && deviceType === 'webview') {
			NativeSupportHandlerV2.openDeeplink(usePaymentMode?.data?.transaction?.redirectURIDeeplink);
			return;
		}
		if (usePaymentMode?.data?.transaction?.redirectURI && deviceType === 'browser') {
			window.open(usePaymentMode?.data?.transaction?.redirectURI, '_top');
		}
	};

	const handleSubmitMode = () => {
		if (reopenPspModal) {
			setIsPSPModalVisible1(true);
			return;
		}

		if (selectedOptionId === 'GPAY') {
			if (!isGpayVpaValid || gpayVpa.slice(0, gpayVpa.indexOf('@')).length < 1) {
				Toasty.error('Please enter a valid VPA.');
				return;
			}
			saveState('upiSelected', 'Google Pay', true);
			saveState('vpaId', gpayVpa, true);
			const payload = {
				transactionMethods: [
					{
						paymentMode: 'UPI',
					},
				],
				payerDetails: {
					payerVpa: gpayVpa,
				},
			};
			dispatch(triggerUpdatePaymentModesApi(payload));
			history.push('/check-status');
			return;
		}

		if (isIOS !== 'INTENT' && selectedOptionId == 'UPI') {
			history.push('/upi-pay');
			return;
		}
		const otpRequiredMode = (paymentModes as any)?.filter(
			(element: any) => (element as any)?.code === selectedOptionId,
		);
		const payload = {
			transactionMethods: [
				{
					paymentMode: selectedOptionId,
				},
			],
			payerDetails: {
				payerVpa: null,
			},
		};
		if ((otpRequiredMode as any)[0]?.otpRequired) {
			const otpPayload = {
				transactionId: globalId,
			};
			setShowOtpModal(true);
			GenerateOtpDetails(otpPayload);
		} else {
			dispatch(triggerUpdatePaymentModesApi(payload));
			if (isShowAlternateUi) {
				showPostpeLoader({
					first_message: 'fetching details',
					start_index: 0,
					range: 8,
					second_message: '',
				});
			}
			return;
		}
	};

	useEffect(() => {
		if (selectedGateway !== 'CASHFREE') return;

		const paymentLink = postPaymentModesResponse?.data?.paymentURI;

		if (paymentLink) {
			if (paymentLink.includes('http')) {
				removePostpeLoader();
				window.location.replace(paymentLink);
				return;
			}
			initialiseCashfreeSdk(paymentLink);
		}
	}, [postPaymentModesResponse?.data?.paymentURI, selectedGateway]);

	const initialiseCashfreeSdk = async (paymentSessionId: string | number) => {
		const res = await loadScript('https://sdk.cashfree.com/js/ui/2.0.0/cashfree.prod.js');

		if (!res) {
			removePostpeLoader();
			alert('Cashfree SDK failed to load. Are you online?');
			return;
		}

		const cashfree = new window.Cashfree(paymentSessionId);
		removePostpeLoader();
		cashfree.redirect();
	};

	useEffect(() => {
		if (selectedGateway !== 'RAZORPAY') return;

		if (postPaymentModesResponse?.data?.callbackURI) {
			removePostpeLoader();
			if (selectedOptionId === 'NB') {
				setShowBankSelectModal(true);
				return;
			}
			setShowCardInfoInput(true);
			if (
				postPaymentModesResponse?.data?.savedCardResponseDtoList &&
				postPaymentModesResponse?.data?.savedCardResponseDtoList.length > 0
			) {
				setSavedCardsList(postPaymentModesResponse?.data?.savedCardResponseDtoList);
				return;
			}
			setIsAddNewCard(true);
		}
	}, [postPaymentModesResponse?.data?.callbackURI, selectedGateway, selectedOptionId]);

	const resendOTP = () => {
		const payload = {
			transactionId: globalId,
		};
		ResendOtpDetails(payload);
	};

	const verifyOTP = async (otpValue: any) => {
		const otpRequiredMode = (paymentModes as any)?.filter(
			(element: any) => (element as any)?.code === selectedOptionId,
		);
		const otpPayload = {
			payload: {
				transactionMethods: [
					{
						paymentMode: (otpRequiredMode as any)[0]?.code,
					},
					{
						option: (otpRequiredMode as any)[0],
					},
				],
				payerDetails: {
					payerVpa: null,
				},
				otp: otpValue,
				id: globalId,
			},
		};
		dispatch(triggerUpdatePaymentModesApi(otpPayload));
	};

	const onCardHolderNameInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const val = event.target.value;
		setCardHolderName(val);
	};

	const handleCvvChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const val = event.target.value.replace(/[^\dA-Z]/g, '');
		if ((rzpCardType === 'amex' && val.length > 4) || (rzpCardType !== 'amex' && val.length > 3)) return;
		setCardCVV(val);
	};

	const showNativeHeader = () => {
		const heading = usePaymentMode?.data?.headerText || 'Payment In Progress';
		const nativeData = {
			key: 62,
			shouldHeaderVisible: true,
			heading: heading,
		};
		if (window.androidObj && window.androidObj.nativeSupport) {
			window.androidObj.nativeSupport(JSON.stringify(nativeData));
		}
	};

	const loadScript = (src: string) => {
		return new Promise((resolve) => {
			const script = document.createElement('script');
			script.src = src;
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	};

	const submitCardData = async () => {
		if (isShowAlternateUi)
			showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
		else setLoading(true);

		const res = await loadScript('https://checkout.razorpay.com/v1/razorpay.js');

		if (!res) {
			alert('Razorpay SDK failed to load. Are you online?');
			return;
		}

		const razorpay = new window.Razorpay({
			key: postPaymentModesResponse?.data?.gatewayKey,
			image: 'https://d30gqtvesfc1d5.cloudfront.net/ext/pg/pg-logo.png',
			name: usePaymentMode?.data?.user?.Name || 'NA',
			redirect: true,
		});

		const originalAmount = postpeCashbackApplied
			? applyCashbackApiResponse?.data?.payableAmount
			: usePaymentMode?.data?.transaction?.orderAmount;

		const rzpAmount = Number((originalAmount * 100).toFixed(0));

		const data =
			selectedOptionId === 'NB'
				? {
						callback_url: postPaymentModesResponse?.data?.callbackURI,
						amount: rzpAmount,
						currency: 'INR',
						email: 'pg@bharatpe.in',
						contact: '9999999999',
						//notes: { address: '2281, Sector - 8, Faridabad.' },
						order_id: postPaymentModesResponse?.data?.pgRefId,
						method: 'netbanking',
						bank: bankSelected,
				  }
				: isAddNewCard
				? {
						callback_url: postPaymentModesResponse?.data?.callbackURI,
						amount: rzpAmount,
						currency: 'INR',
						email: 'pg@bharatpe.in',
						contact: '9999999999',
						customer_id: postPaymentModesResponse?.data?.customerRefId,
						order_id: postPaymentModesResponse?.data?.pgRefId,
						save: isSaveCard ? 1 : null,
						method: 'card',
						'card[number]': cardNoTrimmed,
						'card[expiry_month]': cardMonthValue.substr(0, 2),
						'card[expiry_year]': cardMonthValue.substr(3),
						'card[cvv]': cardCVV,
						'card[name]': cardHolderName,
				  }
				: {
						callback_url: postPaymentModesResponse?.data?.callbackURI,
						amount: rzpAmount,
						currency: 'INR',
						email: 'pg@bharatpe.in',
						contact: '9999999999',
						customer_id: postPaymentModesResponse?.data?.customerRefId,
						order_id: postPaymentModesResponse?.data?.pgRefId,
						method: 'card',
						token: savedCardsList[cardFocused]?.tokenId,
						'card[cvv]': savedCardsCVV,
				  };
		//console.log('-----------------razorPay Payload---------------', data);
		//showNativeHeader();
		setTimeout(() => removePostpeLoader(), 1000);
		razorpay.createPayment(data);
	};

	const isAddCardButtonDisabled = () => {
		return !isAddNewCard
			? (savedCardsList[cardFocused]?.network.toLowerCase() === 'amex' && savedCardsCVV.length < 4) ||
					(savedCardsList[cardFocused]?.network.toLowerCase() !== 'amex' && savedCardsCVV.length < 3)
			: isShowCardNoError ||
					isShowCardMonthError ||
					(rzpCardType === 'amex' && cardNoTrimmed.length < 15) ||
					(rzpCardType === 'amex' && cardCVV.length < 4) ||
					(rzpCardType !== 'amex' && cardNoTrimmed.length < 16) ||
					(rzpCardType !== 'amex' && cardCVV.length < 3) ||
					cardMonthValue.length < 5 ||
					cardHolderName.length < 3;
	};

	const getBankLogoContainer = (info: any, index: number) => {
		return (
			<div
				className={`${bankSelected === info?.gatewayBankCode ? classes.borderCardBlue : ''} ${
					classes.bankCardLogoStyle
				} flex flex-column p2 flex-center`}
				key={index}
				onClick={() => setBankSelected(info?.gatewayBankCode)}>
				<img
					src={
						info?.image
							? info?.image
							: 'https://d30gqtvesfc1d5.cloudfront.net/ext/app_essential/Images/bank_icon/bank_default.png'
					}
					className={`${info?.image ? classes.bankLogoImg : classes.bankLogoImgDefault} mb2`}
				/>
				<span className={classes.bankListTextStyle}>{info?.displayName}</span>
			</div>
		);
	};

	const isCardNumberValid = (inputNum: string) => {
		let digit, flag, sum, _i, _len;
		flag = true;
		sum = 0;
		const digits = (inputNum + '').split('').reverse();
		for (_i = 0, _len = digits.length; _i < _len; _i++) {
			digit = digits[_i];
			digit = parseInt(digit, 10);
			if ((flag = !flag)) {
				digit *= 2;
			}
			if (digit > 9) {
				digit -= 9;
			}
			sum += digit;
		}
		return sum % 10 === 0;
	};

	const isPostpeCard = (inputNum: string) => {
		return inputNum.substr(0, 6) === '437416';
	};

	const isIncorrectCardType = (cardInfoType: string) => {
		return cardInfoType !== selectedOptionId;
	};

	const creditCardType = (cc: string) => {
		const amex = new RegExp('^3[47][0-9]{13}$');
		const visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');

		const mastercard = new RegExp('^5[1-5][0-9]{14}$');
		const mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

		const rupay = /^6(?!011)(?:0[0-9]{14}|52[12][0-9]{12})$/; //^6[0-9]{15}$

		if (visa.test(cc)) {
			return 'visa';
		}
		if (amex.test(cc)) {
			return 'amex';
		}
		if (mastercard.test(cc) || mastercard2.test(cc)) {
			return 'mastercard';
		}
		if (rupay.test(cc)) {
			return 'rupay';
		}
		return '';
	};

	const getCardTypeIcon = (cc: string) => {
		switch (cc) {
			case 'mastercard':
				return 'masterIcon';
			case 'visa':
				return 'visaIcon';
			case 'amex':
				return 'amexIcon';
			case 'rupay':
				return 'rupayIcon';
			default:
				return '';
		}
	};

	const togglePostpeCashback = () => {
		showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
		dispatch(
			triggerApplyPostpeCashbackApi({
				orderId: usePaymentMode?.data?.transaction?.orderId,
				isApplied: !isCashbackCheckboxChecked,
			}),
		);
	};

	const handlePostpeCashbackCheckbox = () => {
		setIsCashbackCheckboxChecked(!isCashbackCheckboxChecked);
	};

	if (showBankList)
		return (
			<>
				{isShowAlternateUi ? (
					<HeaderPostPe
						leftIconAction={() => {
							bankListCallback(false);
							setShowBankList(false);
						}}
						title="Select your bank"
						leftIcon={<img src={backArrowPostPe} />}
					/>
				) : (
					<Header
						leftIconAction={() => {
							bankListCallback(false);
							setShowBankList(false);
						}}
						title="Select your bank"
					/>
				)}
				<BankList
					bankList={{ data: netbankingOptions, status: true }}
					bankSelectedCallback={(val: string) => {
						setBankSelected(val);
					}}
					payNowCallback={() => submitCardData()}
				/>
			</>
		);

	return (
		<div className={classes.root}>
			{!isShowAlternateUi && (isShowTwelvePcUI ? <LoaderNew loading={loading} /> : <Loader loading={loading} />)}
			<div className={fullScreen ? classes.mainContainer : ''}>
				{isShowPostPeUI ? (
					<Box className={`${classes.postPeAmountCard} ${isShowCashbackCard ? 'mb2' : 'mb6'}`}>
						<Box className={classes.paymentHeader}>
							<Box display="flex" flexDirection="column">
								<span className={classes.amountPayStyle}>amount to pay</span>
								<span className={classes.amountPayValue}>{`Rs ${formatCurrency(
									postpeCashbackApplied ? postpeCashbackPayableAmount : usePaymentMode?.data?.transaction?.orderAmount,
								)}`}</span>
							</Box>
							<img src={postPeMoneyIcon} className="" />
						</Box>
					</Box>
				) : isShowUnityUi ? (
					<Box className={`${classes.unityPaymentAmountCard} p4 mb6`}>
						<Box display="flex" flexDirection="column">
							<span className={classes.amountPayStyle}>Amount to pay</span>
							<div className="">
								<span className={classes.rupeeSymbolUnity}>₹&nbsp;</span>
								<span className={classes.amountPayValue}>{`${formatCurrency(
									usePaymentMode?.data?.transaction?.orderAmount,
								)}`}</span>
							</div>
						</Box>
					</Box>
				) : (
					<Box className={classes.paymentModal}>
						<Box display="flex" flexDirection="column">
							<Box className={classes.paymentHeader}>
								<Typography variant="Light100" className={classes.subHeader}>
									{language.SUB_Header_Text}
								</Typography>
								<Typography variant="Light100" className={classes.subHeader}>
									{language.Amount}
								</Typography>
							</Box>
							<Box className={classes.paymentSubHeader}>
								<Typography variant="SemiBold300" className={classes.subHeader1}>
									{usePaymentMode?.data?.clientName}
								</Typography>
								<Typography variant="SemiBold300">
									{`₹${formatCurrency(usePaymentMode?.data?.transaction?.orderAmount)}`}
								</Typography>
							</Box>
						</Box>
					</Box>
				)}
				{isShowPostPeUI && isShowCashbackCard && (
					<Box
						className={`${classes.postPeAmountCard} ${classes.postpeCashbackCardColor} mb6`}
						onClick={togglePostpeCashback}>
						<Box className={classes.paymentHeader}>
							<Box display="flex" alignItems="center">
								<span className={classes.amountPayStyle}>available cashback:&nbsp;</span>
								<span className={classes.availableCashback}>
									{formatCurrency(postpeCashbackDetailsResponse?.data?.maxApplicableCashback)}
								</span>
							</Box>
							<FormControlLabel
								className={classes.postpeCashbackCardMargin}
								control={
									<Checkbox
										checked={isCashbackCheckboxChecked}
										className="py0"
										checkedIcon={<Icon icon={check} height={16} />}
										icon={<Icon icon={uncheck} height={16} />}
									/>
								}
								label={''}
							/>
						</Box>
					</Box>
				)}
				{isShowAlternateUi ? (
					<span className={classes.selectPaymentText}>{language.SELECT_PAYMENT_METHOD}</span>
				) : (
					<Typography variant="SemiBold200" className={classes.selectPaymentMethodText}>
						{language.SELECT_PAYMENT_METHOD}
					</Typography>
				)}
				{!isShowAlternateUi &&
					(isShowSwipeModes ? isShowAllModes : true) &&
					normalPaymentModes &&
					normalPaymentModes?.length > 0 && (
						<div className={classes.outlinePayment}>
							<PaymentOptionsList
								list={normalPaymentModes}
								onSelected={(list, id) => {
									setSelectedoptionId(list?.id);
									setSelectedGateway(list?.paymentGateway);
								}}
							/>
						</div>
					)}
				{!isShowAlternateUi && !isShowAllModes && swipePaymentModes && swipePaymentModes?.length > 0 && (
					<div className={classes.outlinePayment}>
						<PaymentOptionsList
							list={swipePaymentModes}
							onSelected={(list, id) => {
								setSelectedoptionId(list?.id);
								setSelectedGateway(list?.paymentGateway);
							}}
						/>
					</div>
				)}
				{!!isShowAlternateUi && normalPaymentModes && normalPaymentModes?.length > 0 && (
					<div className={classes.outlinePayment}>
						<PostpePaymentOptionsList
							list={normalPaymentModes}
							onSelected={(list: any, id: any) => {
								setSelectedoptionId(list?.id);
								setSelectedGateway(list?.paymentGateway);
							}}
							isShowUnityUi={isShowUnityUi}
						/>
					</div>
				)}
				{!isShowAlternateUi && isShowSwipeModes && !isShowAllModes && (
					<div className="flex flex-center flex-justify-end my4">
						<Typography variant="SemiBold200" className="primary" onClick={() => setIsShowAllModes(true)}>
							More Payment Modes
						</Typography>
						<Icon icon={downArrowBlue} width={12} className="ml1" />
					</div>
				)}
				{!isShowAlternateUi && (
					<Box display="flex" flexDirection="row" justifyContent="center">
						<img src={Icon1} />
						<Typography>{language.SAFE_SECURE}</Typography>
					</Box>
				)}
				{!!isShowTwelvePcUI && (
					<div className="flex flex-column mt6">
						<span className={classes.twelvepcLendenText}>
							*LendenClub is the RBI approved P2P NBFC that we use to facilitate your investment & Hindon is the RBI
							approved NBFC to facilitate your borrowing
						</span>
						<Box display="flex" alignItems="center" justifyContent="center" className="mt6">
							<Typography variant="Light300" className="mr1 grey">
								Powered By BharatPe
							</Typography>
							<img src={bharatPeIcon} className={classes.bharatpeIcon} />
						</Box>
					</div>
				)}
			</div>
			{isShowTwelvePcUI ? (
				<>
					<div className={classes.bottomBlock}></div>
					<div className={`${classes.footerNewContainer} pb2 px1 flex flex-center flex-justify-center width-100 fixed`}>
						<button
							className={`${classes.twelvePcButton} fs-14`}
							onClick={() => handleSubmitMode()}
							disabled={selectedOptionId?.length === 0}>
							{`${language.PAY} ₹${formatCurrency(usePaymentMode?.data?.transaction?.orderAmount)}`}
						</button>
					</div>
				</>
			) : isShowAlternateUi ? (
				<>
					<div className={`${classes.footerNewContainer} pb2 px1 flex flex-center flex-justify-center width-100 fixed`}>
						<button
							className={`${classes.postpeButton}`}
							onClick={() => handleSubmitMode()}
							disabled={selectedOptionId?.length === 0}>
							{isShowUnityUi ? 'CONTINUE' : 'Continue'}
						</button>
					</div>
				</>
			) : (
				<Footer>
					<Button size="large" onClick={handleSubmitMode} disabled={selectedOptionId?.length === 0}>
						{`${language.PAY} ₹${formatCurrency(usePaymentMode?.data?.transaction?.orderAmount)}`}
					</Button>
				</Footer>
			)}
			<BottomSheet
				visible={showOtpModal}
				rounded={true}
				roundRadius={30}
				//onClose={() => setShowOtpModal(false)}
				showCloseButton={false}
				fullscreen={false}>
				<div>
					<Typography variant="SemiBold300" className={classes.otpHeader}>
						{language.VERIFY_OTP}
					</Typography>
					<OTPCard
						content={`${language.ENETR_OTP_SENT_TO} ${(merchantData as any)?.mobileNumber}`}
						otpLength={4}
						onResendClick={resendOTP}
						onVerifyClick={verifyOTP}
						fillFooter={true}></OTPCard>
				</div>
			</BottomSheet>
			<BottomSheet
				visible={showCardInfoInput}
				rounded={true}
				roundRadius={15}
				onClose={() => {
					//setShowCardInfoInput(false);
					TriggerCancelPaymentApi();
				}}
				showCloseButton={true}
				fullscreen={false}>
				<div className="flex-column px4 pb4">
					{!isAddNewCard && savedCardsList && savedCardsList.length > 0 ? (
						<>
							<span className={`${classes.cardModalHeading} mb4`}>Saved Cards</span>
							{savedCardsList.map((item: any, index: number) => {
								return (
									<SavedCardItem
										key={index}
										index={index}
										cardInfo={item}
										onCardFocus={(id: number) => {
											//console.log('---------------number selected', id);
											setCardFocused(id);
										}}
										isCardFocused={cardFocused === index}
										onCardCvvValueChange={(val: string) => {
											//console.log('================val returned cvv========', index, val);
											setSavedCardsCVV(val);
										}}
									/>
								);
							})}
							<div className="flex flex-center mb4 flex-justify-end" onClick={() => setIsAddNewCard(true)}>
								<img src={addCardIcon} className="mr1" />
								<span className={classes.addNewCardStyle}>ADD NEW CARD</span>
							</div>
						</>
					) : (
						<>
							<span className={`${classes.cardModalHeading} mb4`}>Add Card</span>
							<InputPostPe
								cardIconId={getCardTypeIcon(rzpCardType)}
								inputRef={inputRef}
								type={'tel'}
								placeholder="Card Number"
								onChange={async (e: any) => {
									if (isShowCardNoError) setIsShowCardNoError(false);
									let value = e.target.value
										.replace(/[^\dA-Z]/g, '')
										.replace(/(.{4})/g, '$1 ')
										.trim();
									const realValue = value.replace(/[^\d/]/gi, '');
									const realLength = realValue.length;
									const cardType = creditCardType(realValue);
									if (cardType) setRzpCardType(cardType);
									if ((cardType === 'amex' && realLength === 15) || realLength === 16) {
										setCardNoTrimmed(realValue);
										let cardInfoType = 'NA';
										await TriggerGetCardInfoApi(realValue.substr(0, 6))
											.then((resp: any) => {
												const card_type = resp.data?.type.toLowerCase();
												switch (card_type) {
													case 'debit':
														cardInfoType = 'DC';
														break;
													case 'credit':
														cardInfoType = 'CC';
														break;
													default:
														break;
												}
											})
											.catch((err) => {
												Toasty.error(err?.message || "Error: Couldn't determine card type");
											});
										if (!isCardNumberValid(realValue) || isPostpeCard(realValue) || isIncorrectCardType(cardInfoType)) {
											setIsShowCardNoError(true);
											setCardNo(value);
											return;
										}
										inputRef2.current.focus();
									}
									if (value.length > 19) value = value.substring(0, 19);
									if ((cardType === 'amex' && realLength < 15) || realLength < 16) setCardNoTrimmed(realValue);
									setCardNo(value);
								}}
								value={cardNo}
								inputContainerClassName="mb4 mt2"
								showError={isShowCardNoError}
								errorMsg={
									isShowAlternateUi
										? 'This card is not accepted for repayment. Please enter a valid card number.'
										: 'Please enter a valid card number'
								}
								UIType={isShowTwelvePcUI ? '12pc' : isShowAlternateUi ? 'postpe' : 'merchant'}
							/>
							<InputPostPe
								inputRef={inputRef2}
								type={'text'}
								placeholder="Card Holder's Name"
								onChange={onCardHolderNameInputChange}
								value={cardHolderName}
								inputContainerClassName="mb4"
								UIType={isShowTwelvePcUI ? '12pc' : isShowAlternateUi ? 'postpe' : 'merchant'}
								//showError={pincode['errorVisibility']}
								//errorMsg={pincode['errorMsg']}
							/>
							<div className="flex flex-center mb4">
								<InputPostPe
									inputRef={inputRef3}
									type={'tel'}
									placeholder="MM/YY"
									onChange={(e: any) => {
										let value = e.target.value;
										if (value.length > 5) return;
										if (isShowCardMonthError) setIsShowCardMonthError(false);
										if (value.length === 3 && cardMonthValue.length > value.length) value = value.substring(0, 2);
										const realValue = value.replace('/', '');
										const realLength = realValue.length;
										if (value.length === 3 && cardMonthValue.length < value.length)
											value = value.substr(0, 2) + '/' + value.substr(2);
										if (realLength === 4) {
											const cardMonth = Number(realValue.substr(0, 2));
											const cardYear = Number(realValue.substr(2));
											if (
												!(cardMonth > 0 && cardMonth < 13) ||
												cardYear < new Date().getFullYear() % 100 ||
												cardYear > (new Date().getFullYear() % 100) + 10 ||
												(cardYear === new Date().getFullYear() % 100 && cardMonth < new Date().getMonth() + 1)
											) {
												setIsShowCardMonthError(true);
												setCardMonthValue(value);
												return;
											}
											inputRef4.current.focus();
										}
										setCardMonthValue(value);
									}}
									value={cardMonthValue}
									inputContainerClassName="mr10"
									showError={isShowCardMonthError}
									errorMsg={'Invalid Date'}
									UIType={isShowTwelvePcUI ? '12pc' : isShowAlternateUi ? 'postpe' : 'merchant'}
								/>
								<InputPostPe
									inputRef={inputRef4}
									type={'password'}
									placeholder="CVV"
									onChange={handleCvvChange}
									value={cardCVV}
									UIType={isShowTwelvePcUI ? '12pc' : isShowAlternateUi ? 'postpe' : 'merchant'}
								/>
							</div>
							{!!Token && (
								<div className="flex flex-center mb4">
									<Switch
										switchClass="mr2"
										activeSwitch={isSaveCard}
										switchCallback={(val: boolean) => {
											setIsSaveCard(val);
										}}
										switchColor={isShowTwelvePcUI ? 'green' : isShowAlternateUi ? 'dark-blue' : 'primary'}
									/>
									<span className={classes.saveCardStyle}>Save this card</span>
								</div>
							)}
						</>
					)}
					{isShowAlternateUi ? (
						<div className={`pb1 flex flex-center flex-justify-center width-100`}>
							<button
								className={`${
									isAddCardButtonDisabled() ? classes.postpeButtonDisabled : classes.postpeButton
								} width-100`}
								onClick={submitCardData}
								disabled={isAddCardButtonDisabled()}>
								PAY NOW
							</button>
						</div>
					) : isShowTwelvePcUI ? (
						<div className={`pb1 flex flex-center flex-justify-center width-100`}>
							<button
								className={` ${isAddCardButtonDisabled() ? classes.twelvePcButtonDisabled : classes.twelvePcButton} ${
									classes.width100Imp
								} fs-14`}
								onClick={submitCardData}
								disabled={isAddCardButtonDisabled()}>
								PAY NOW
							</button>
						</div>
					) : (
						<div className={`pb1 width-100 flex flex-column`}>
							<Button size="large" onClick={submitCardData} disabled={isAddCardButtonDisabled()}>
								PAY NOW
							</Button>
						</div>
					)}
				</div>
			</BottomSheet>
			<BottomSheet
				visible={showBankSelectModal}
				rounded={true}
				roundRadius={15}
				onClose={() => {
					//setShowBankSelectModal(false);
					TriggerCancelPaymentApi();
				}}
				showCloseButton={true}
				fullscreen={false}>
				<div className="flex-column px4 pb4">
					<span className={`${classes.cardModalHeading} mb4`}>Netbanking</span>
					<div className={`${classes.bankListOuterLayout} mb2`}>
						{netbankingOptions &&
							netbankingOptions.length > 0 &&
							netbankingOptions.map((item: any, index: number) => {
								return index < 16 && getBankLogoContainer(item, index);
							})}
					</div>
					{!!(netbankingOptions && netbankingOptions.length > 15) && isShowAlternateUi ? (
						<div className={`pb2 flex flex-center flex-justify-center width-100`}>
							<button
								className={`${classes.postpeMoreBanksButton} width-100`}
								onClick={() => {
									bankListCallback(true);
									setShowBankList(true);
								}}>
								MORE BANKS
							</button>
						</div>
					) : isShowTwelvePcUI ? (
						<div className={`pb2 flex flex-center flex-justify-center width-100`}>
							<button
								className={`${classes.twelvePcButtonOutline} ${classes.width100Imp} fs-14`}
								onClick={() => {
									bankListCallback(true);
									setShowBankList(true);
								}}>
								MORE BANKS
							</button>
						</div>
					) : (
						<div className={`pb2 width-100 flex flex-column`}>
							<Button
								variant="outlined"
								size="large"
								onClick={() => {
									bankListCallback(true);
									setShowBankList(true);
								}}>
								MORE BANKS
							</Button>
						</div>
					)}
					{isShowAlternateUi ? (
						<div className={`pb1 flex flex-center flex-justify-center width-100`}>
							<button
								className={`${!bankSelected ? classes.postpeButtonDisabled : classes.postpeButton} width-100`}
								onClick={submitCardData}
								disabled={!bankSelected}>
								PAY NOW
							</button>
						</div>
					) : isShowTwelvePcUI ? (
						<div className={`pb1 flex flex-center flex-justify-center width-100`}>
							<button
								className={`${classes.twelvePcButton} ${!bankSelected ? classes.twelvePcButtonDisabled : ''} ${
									classes.width100Imp
								} fs-14`}
								onClick={submitCardData}
								disabled={!bankSelected}>
								PAY NOW
							</button>
						</div>
					) : (
						<div className={`pb1 width-100 flex flex-column`}>
							<Button size="large" onClick={submitCardData} disabled={!bankSelected}>
								PAY NOW
							</Button>
						</div>
					)}
				</div>
			</BottomSheet>
			{upiIntentLoader && !isShowAlternateUi && (
				<div className={classes.paymentLoaderMainContainer}>
					<div className={!isCancelIntentModalVisible ? classes.loaderBackground : classes.opaq}>
						{isShowTwelvePcUI ? (
							<img src={newLoader} alt="" className={classes.newLoaderElement} />
						) : (
							<img src={LoaderImageNew} alt="" className={classes.loaderElement} />
						)}
						{fiveMinTimer ? (
							<>
								{isShowAlternateUi ? (
									<span className={`${classes.textLonger} mb1 text-center`}>{language.TAKING_LONGER}</span>
								) : (
									<Typography variant="Regular300" className="mb1 text-center">
										{language.TAKING_LONGER}
									</Typography>
								)}
								<Timer timeLeft={300000} onTimerUp={false} timerUpAction={() => handleBack()} />
							</>
						) : isShowAlternateUi ? (
							<span className={`${classes.textLonger}`}>{language.PROCESSING_PAYMENT}</span>
						) : (
							<Typography variant="Regular300">{language.PROCESSING_PAYMENT}</Typography>
						)}
						{isShowAlternateUi ? (
							<button
								className={`${classes.postpeButton} ${classes.postpeButtonFont} mt2`}
								onClick={() => setIsCancelIntentModalVisible(true)}>
								{language.CANCEL}
							</button>
						) : isShowTwelvePcUI ? (
							<button
								className={`${classes.twelvePcButton} fs-20 mt2`}
								onClick={() => setIsCancelIntentModalVisible(true)}>
								{language.CANCEL}
							</button>
						) : (
							<Button
								variant="contained"
								className="mt2 fs-20 px16"
								onClick={() => setIsCancelIntentModalVisible(true)}>
								<Typography variant={'SemiBold300'}>{language.CANCEL}</Typography>
							</Button>
						)}
					</div>
					{isCancelIntentModalVisible && (
						<div className={classes.loaderBackground}>
							{isShowAlternateUi ? (
								<span className={`${classes.textLonger} text-center`}>{language.WANT_TO_EXIT}</span>
							) : (
								<Typography variant="Regular400">{language.WANT_TO_EXIT}</Typography>
							)}
							<div className={classes.loaderText}>
								{isShowAlternateUi ? (
									<>
										<button
											className={`${classes.postpeButtonOutline} ${classes.postpeButtonFont} mr5 px10`}
											onClick={() => handleBack()}>
											{language.YES}
										</button>
										<button
											className={`${classes.postpeButton} ${classes.postpeButtonFont} px10`}
											onClick={() => setIsCancelIntentModalVisible(false)}>
											{language.NO}
										</button>
									</>
								) : isShowTwelvePcUI ? (
									<>
										<button className={`${classes.twelvePcButtonOutline} fs-14 mr5 px10`} onClick={() => handleBack()}>
											{language.YES}
										</button>
										<button
											className={`${classes.twelvePcButton} fs-14 px10`}
											onClick={() => setIsCancelIntentModalVisible(false)}>
											{language.NO}
										</button>
									</>
								) : (
									<>
										<Button variant="outlined" onClick={handleBack} className="mr5 px7">
											<Typography variant="SemiBold300">{language.YES}</Typography>
										</Button>
										<Button variant="contained" onClick={() => setIsCancelIntentModalVisible(false)} className="px7">
											<Typography variant="SemiBold300">{language.NO}</Typography>
										</Button>
									</>
								)}
							</div>
						</div>
					)}
					<div className={classes.loader__overlay} />
				</div>
			)}
		</div>
	);
};

export default PaymentMethod;
